import React, { useState, useEffect } from "react";
import { Checkbox, FormControl, Input, InputLabel, ListItemText, MenuItem, Select } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

export const MultiSelect = ({ list, handleChange, value, labelName, disabled }) => {
  const classes = useStyles();
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    setSelectedIds(value);
  }, [value]);

  const handleChangeMulti = (event) => {
    const newSelectedIds = event.target.value;
    setSelectedIds(newSelectedIds);
    handleChange(newSelectedIds);
  };

  return (
    <>
      <FormControl className={clsx(classes.formControl, classes.noLabel)}>
        <InputLabel>{labelName}</InputLabel>
        <Select
          multiple
          disabled={disabled}
          value={selectedIds}
          onChange={handleChangeMulti}
          input={<Input />}
          renderValue={(selected) => selected.map((id) => list.find((item) => item.id === id)?.name || "").join(", ")}
        >
          {list.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              <Checkbox checked={selectedIds.includes(item.id)} />
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};
